export enum NewsStatusEnum {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum NewsStatusStringEnum {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
}